import { ApiModelProperty } from '@nestjs/swagger/dist/decorators/api-model-property.decorator';
import { ulid } from 'ulid';
import { BazaNcPayoffDistributionTransactionStatus } from '../models/baza-nc-payoff-distribution-transaction-status';

export class BazaNcPayoffDistributionTransactionDto {
    @ApiModelProperty({
        description: 'ULID (ID)',
        example: ulid(),
    })
    ulid: string;

    @ApiModelProperty({
        description: 'Date Created At',
        example: new Date().toISOString(),
    })
    dateCreatedAt: string;

    @ApiModelProperty({
        description: 'Date Updated At',
        example: new Date().toISOString(),
        required: false,
    })
    dateUpdatedAt?: string;

    @ApiModelProperty({
        description: 'Date Processed At',
        example: new Date().toISOString(),
        required: false,
    })
    dateProcessedAt?: string;

    @ApiModelProperty({
        type: 'string',
        description: 'Status',
        enum: Object.values(BazaNcPayoffDistributionTransactionStatus),
        example: BazaNcPayoffDistributionTransactionStatus.Draft,
    })
    status: BazaNcPayoffDistributionTransactionStatus;

    @ApiModelProperty({
        description: 'Transaction Title',
    })
    title: string;

    @ApiModelProperty({
        description: 'Can be deleted?',
        example: 'PayoffDistribution Transaction 1',
    })
    canBeDeleted: boolean;

    @ApiModelProperty({
        description: 'Is PayoffDistribution Transaction locked?',
    })
    isLocked: boolean;

    @ApiModelProperty({
        description: 'Is PayoffDistribution Transaction processing now?',
    })
    isProcessing: boolean;
}
